import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import DropdownValues from "../Student/Reusablecomponents/DropDownValues";
import axios from "axios";
import { Row, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";
import axiosInstance from "../ReusableComponents/Axios";

export function Situation(props) {
  const [SituationOptions, SetSituationOptions] = useState();

  const GetLevelone = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SID}&LovCategoryId=${props.LID}&ParentLovId=0`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const PID = res.data.filter((item) => item.lovName === "Situation" || item.lovName === "स्थिति" || item.lovName === "పరిస్థితి" );
        axios
          .get(
            process.env.REACT_APP_API_BASE_URL +
            `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SID}&LovCategoryId=${parseInt(props.LID) + 1}&ParentLovId=${PID?.[0]?.lovId}`,
            { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
          )
          .then((res) => {
            const Options = res.data.map((item) => ({
              display: item.lovName,
              value: item.lovId,
            }));
            SetSituationOptions(Options);
            props.StoreMSource(props.SOption || "");
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    GetLevelone();
  }, []);

  return (
    <DropdownValues
      className={props.className}
      options={SituationOptions}
      selectoption={props.SOption}
      onChange={(e) => props.onChange(e.target.value)}
      disabled={props.disable}
      labelname={props.labelname}
      Displayname={props.Displayname}
    />
  );
}

export function TextFormat(props) {
  const [TextFormatOptions, SetTextFormatOptions] = useState();

  const GetLeveltwo = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/Scenario/GetTextFormatLOValues?LovCategoryId=${props.LID}&SubjectId=${props.SID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovName,
          value: item.lovId,
        }));
        SetTextFormatOptions(Options);
        props.StoreMSource(props.SOption || "");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    GetLeveltwo();
  }, []);

  return (
    <>
      <DropdownValues
        className={props.className}
        options={TextFormatOptions}
        selectoption={props.SOption}
        onChange={(e) => props.onChange(e.target.value)}
        disabled={props.disable}
        labelname={props.labelname}
        Displayname={props.Displayname}
      />
    </>
  );
}

export function TType(props) {
  const [TTypeOptions, SetTTypeOptions] = useState();

  const GetLevelthree = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/Scenario/GetTextTypeLOValues?LovCategoryId=${props.LID}&SubjectId=${props.SID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovName,
          value: item.lovId,
        }));
        SetTTypeOptions(Options);
        props.StoreMSource(props.SOption || "");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    GetLevelthree();
  }, []);

  return (
    <>
      <DropdownValues
        className={props.className}
        options={TTypeOptions}
        selectoption={props.SOption}
        onChange={(e) => props.onChange(e.target.value)}
        disabled={props.disable}
        labelname={props.labelname}
        Displayname={props.Displayname}
      />
    </>
  );
}

export function GradeDD(props) {
  const [GradeOptions, SetGradeOptions] = useState();

  const GetGrades = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=0&LovCategoryId=14&ParentLovId=0`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovName,
          value: item.lovId,
        }));
        SetGradeOptions(Options);
        if (props.Change) {
          const Sdata = Options.find((item) => item.value == parseInt(props.SOption));
          props.StoreMSource(Sdata);
        } else {
          props.StoreMSource(props.SOption || { display: 'ggg', value: "0" });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    GetGrades();
  }, []);
  const Getalldata = (e) => {
    if (props.Change) {
      const Sdata = GradeOptions.find((item) => item.value == e.target.value);
      props.StoreMSource(Sdata);
      //console.log(e.target.value,"Sdata",Sdata)
    }
    props.onChange(e.target.value)
  };
  return (
    <>
      <DropdownValues
        className={props.className}
        options={GradeOptions}
        selectoption={props.SOption}
        onChange={(e) => Getalldata(e)}
        // onChange={(e) => props.onChange(e.target)}
        disabled={props.disable}
        labelname={props.labelname}
        Displayname={props.Displayname}
      />
    </>
  );
}

export function Booktype(props) {
  const [BTypeOptions, SetBTypeOptions] = useState();

  const GetBTypes = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=0&LovCategoryId=64&ParentLovId=0`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovName,
          value: item.lovId,
        }));
        SetBTypeOptions(Options);
        if (props.Grade === 52 || props.Grade === 51) {
          props.StoreMSource(props.SOption || Options[0]);
        } else {
          props.StoreMSource(Options[0]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
console.log("prop.soption",props.SOption)
  useEffect(() => {
    GetBTypes();
  }, [props.Grade]);

  const HandleChange = (e) => {
    const Sdata = BTypeOptions.find((item) => item.value == e);
    props.onChange(Sdata)
  }
  return (
    <>
      <DropdownValues
        className={props.className}
        options={BTypeOptions}
        selectoption={props.SOption?.value}
        onChange={(e) => { HandleChange(e.target.value); }}
        disabled={props.disable}
        labelname={props.labelname}
      />
    </>
  );
}

export function ChapterDD(props) {
  const [ChapterOptions, SetChapterOptions] = useState();

  const GetChapters = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=0&LovCategoryId=${props.LID}&ParentLovId=0`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovName,
          value: item.lovId,
        }));
        SetChapterOptions(Options);
        props.StoreMSource(props.SOption || "");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    GetChapters();
  }, []);

  return (
    <>
      <DropdownValues
        className={props.className}
        options={ChapterOptions}
        selectoption={props.SOption}
        onChange={(e) => props.onChange(e.target.value)}
        disabled={props.disable}
        labelname={props.labelname}
        Displayname={props.Displayname}
      />
    </>
  );
}

export function BookDD(props) {
  const [BookOptions, SetBookOptions] = useState();
  const GetBooks = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/Scenario/GetBookDetailsonGradeAndUnit?Grade=${props.Grade}&Unit=${props.Chapter}&GCType=${props.GCtype}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.engBookValue,
          value: item.engBookLovId,
        }));
        SetBookOptions(Options);
        if (Options.filter((item) => item.value === props.SOption).length > 0) {
          props.StoreMSource(props.SOption);
        } else {
          props.StoreMSource("");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (props.Chapter && props.Grade && props.GCtype) {
      GetBooks();
    }
  }, [props.Grade, props.Chapter, props.GCtype]);

  return (
    <>
      <DropdownValues
        className={props.className}
        options={BookOptions}
        selectoption={props.SOption}
        onChange={(e) => props.onChange(e.target.value)}
        disabled={props.disable}
        labelname={props.labelname}
        Displayname={props.Displayname}
      />
    </>
  );
}

const BookSubDropDowns = (props) => {
  const dispatch = useDispatch();

  const [BSDD, SetBSDD] = useState({ MR: "", Poem: "", NDL: "" });
  const [SValue, SetSValue] = useState({
    MR: props.SOption?.MR || "",
    Poem: props.SOption?.Poem || "",
    NDL: props.SOption?.NDL || "",
  });

  const GetMReading = async () => {
    SetBSDD({ MR: "", Poem: "", NDL: "" });
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/Scenario/GetAllBookDetails?Grade=${props.Grade}&Unit=${props.Chapter}&Book=${props.Book}&GCType=${props.GCtype}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const MR = [];
        const Poem = [];
        const NDL = [];
 const mrSet = new Set();
        const poemSet = new Set();

        res.data.forEach((item) => {
          if (item.engMainReadingLovId   &&
            !mrSet.has(item.engMainReadingLovId)) {
              mrSet.add(item.engMainReadingLovId);
            MR.push({
              display: item.engMainReadingValue,
              value: item.engMainReadingLovId,
            });
          }
          if (item.engMainReadingPoemLovId &&
            !poemSet.has(item.engMainReadingPoemLovId)) {
               poemSet.add(item.engMainReadingPoemLovId);
            Poem.push({
              display: item.engMainReadingPoemValue,
              value: item.engMainReadingPoemLovId,
            });
          }
          if (item.engLessonLovId) {
            NDL.push({
              display: item.engLessonValue,
              value: item.engLessonLovId,
            });
          }
        });
        SetBSDD({ MR: MR, Poem: Poem, NDL: NDL });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (props.Grade && props.Chapter && props.Book && props.GCtype) {
      GetMReading();
    }
  }, [props.Grade, props.Chapter, props.Book, props.GCtype]);

  const HandleoNchange = (e, Name) => {
    SetSValue({ ...SValue, [Name]: e });
    props.StoreMSource({ ...SValue, [Name]: e });
  };
  return (
    <>
      <Row>
        <Col>
          {" "}
          <DropdownValues
            className={props.className}
            options={BSDD?.MR}
            selectoption={SValue.MR}
            onChange={(e) => HandleoNchange(e.target.value, "MR")}
            disabled={props.disable}
            labelname={<div className="DropdownHeader">Main Reading</div>}
            Displayname="Select Main Reading"
          />
        </Col>

        <Col>
          {" "}
          <DropdownValues
            className={props.className}
            options={BSDD?.Poem}
            selectoption={SValue.Poem}
            onChange={(e) => HandleoNchange(e.target.value, "Poem")}
            disabled={props.disable}
            labelname={<div className="DropdownHeader">Poem</div>}
            Displayname="Select Poem"
          />
        </Col>

        <Col>
          {" "}
          <DropdownValues
            className={props.className}
            options={BSDD?.NDL}
            selectoption={SValue.NDL}
            onChange={(e) => HandleoNchange(e.target.value, "NDL")}
            disabled={props.disable}
            labelname={
              <div className="DropdownHeader">Non-Detailed Lesson</div>
            }
            Displayname="Select Non-Detailed Lesson"
          />
        </Col>
      </Row>
    </>
  );
};
export default BookSubDropDowns;

export function BookTypeSubDropDowns(props) {
  const [BTSDD, SetBTSDD] = useState({
    SS: "",
    Poem: "",
    NFI: "",
    DI: "",
    Essay: "",
  });
  const [SValue, SetSValue] = useState({
    SS: props.SOption?.SS || "",
    Poem: props.SOption?.Poem || "",
    NFI: props.SOption?.NFI || "",
    DI: props.SOption?.DI || "",
    Essay: props.SOption?.Essay || "",
  });

  const GetMReading = async () => {
    SetBTSDD({ SS: "", Poem: "", NFI: "", DI: "", Essay: "" });
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/Scenario/GetAllBookDetails?Grade=${props.Grade}&Unit=${props.Chapter}&Book=${props.Book}&GCType=${props.GCtype}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        SetBTSDD({
          SS: res.data[0].shortstoriesId && [
            {
              display: res.data[0].shortStories,
              value: res.data[0].shortstoriesId,
            },
          ],
          Poem: res.data[0].engMainReadingPoemLovId && [
            {
              display: res.data[0].engMainReadingPoemValue,
              value: res.data[0].engMainReadingPoemLovId,
            },
          ],
          NFI: res.data[0].nonFictionIntroductionId && [
            {
              display: res.data[0].nonFictionIntroduction,
              value: res.data[0].nonFictionIntroductionId,
            },
          ],
          DI: res.data[0].dramaIntroductionId && [
            {
              display: res.data[0].dramaIntroduction,
              value: res.data[0].dramaIntroductionId,
            },
          ],
          Essay: res.data[0].essayId && [
            { display: res.data[0].essay, value: res.data[0].essayId },
          ],
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (props.Grade && props.Chapter && props.Book && props.GCtype) {
      GetMReading();
    }
  }, [props.Grade, props.Chapter, props.Book, props.GCtype]);

  const HandleoNchange = (e, Name) => {
    SetSValue({ ...SValue, [Name]: e });
    props.StoreMSource({ ...SValue, [Name]: e });
  };
    console.log("SValue",SValue);

  return (
    <>
      <Row>
        <Col>
          {" "}
          <DropdownValues
            className={props.className}
            options={BTSDD?.SS}
            selectoption={SValue?.SS}
            onChange={(e) => HandleoNchange(e.target.value, "SS")}
            disabled={props.disable}
            labelname={<div className="DropdownHeader">Short Stories</div>}
            Displayname="Select Short Stories"
          />
        </Col>

        <Col>
          {" "}
          <DropdownValues
            className={props.className}
            options={BTSDD?.Poem}
            selectoption={SValue?.Poem}
            onChange={(e) => HandleoNchange(e.target.value, "Poem")}
            disabled={props.disable}
            labelname={<div className="DropdownHeader">Poem</div>}
            Displayname="Select Poem"
          />
        </Col>

        {props.Grade === 51 ? (
          <Col>
            {" "}
            <DropdownValues
              className={props.className}
              options={BTSDD?.Essay}
              selectoption={SValue?.Essay}
              onChange={(e) => HandleoNchange(e.target.value, "Essay")}
              disabled={props.disable}
              labelname={<div className="DropdownHeader">Essay</div>}
              Displayname="Select Essay"
            />
          </Col>
        ) : (
          <>
            <Col>
              {" "}
              <DropdownValues
                className={props.className}
                options={BTSDD?.NFI}
                selectoption={SValue?.NFI}
                onChange={(e) => HandleoNchange(e.target.value, "NFI")}
                disabled={props.disable}
                labelname={
                  <div className="DropdownHeader">Non-Fiction Introduction</div>
                }
                Displayname="Select Non-Fiction Introduction"
              />
            </Col>

            <Col>
              {" "}
              <DropdownValues
                className={props.className}
                options={BTSDD?.DI}
                selectoption={SValue?.DI}
                onChange={(e) => HandleoNchange(e.target.value, "DI")}
                disabled={props.disable}
                labelname={
                  <div className="DropdownHeader">Drama-Introduction</div>
                }
                Displayname="Select Drama-Introduction"
              />
            </Col>
          </>
        )}
      </Row>
    </>
  );
}

// export function Stage(props) {
//   const [Options, SetOptions] = useState();
//   const GetStage = async () => {
//     await axios
//       .get(
//         process.env.REACT_APP_API_BASE_URL +
//         `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=0&LovCategoryId=${props.LID}&ParentLovId=0`,
//         { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
//       )
//       .then((res) => {
//         const Options = res.data.map((item) => ({
//           display: item.lovDescription,
//           value: item.lovId,
//         }));
//         SetOptions(Options);
//         props.StoreMSource(props.SOption || "");
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   };

//   useEffect(() => {
//     GetStage();
//   }, []);

//   return (
//     <>
//       <DropdownValues
//         Displayname={props.Displayname}
//         className={props.className}
//         options={Options}
//         selectoption={props.SOption}
//         onChange={(e) => props.onChange(e.target.value)}
//         disabled={props.disable}
//         labelname={props.labelname}
//       />
//     </>
//   );
// }
// export function CircularGoal(props) {
//   const [Options, SetOptions] = useState();
//   const GetCGoal = async () => {
//     await axios
//       .get(
//         process.env.REACT_APP_API_BASE_URL +
//         `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=0&LovCategoryId=${props.LID}&ParentLovId=0`,
//         { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
//       )
//       .then((res) => {
//         const Options = res.data.map((item) => ({
//           display: item.lovDescription,
//           value: item.lovId,
//         }));
//         SetOptions(Options);
//         props.StoreMSource(props.SOption || "");
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   };

//   useEffect(() => {
//     GetCGoal();
//   }, []);

//   return (
//     <>
//       <DropdownValues
//         Displayname={props.Displayname}
//         className={props.className}
//         options={Options}
//         selectoption={props.SOption}
//         onChange={(e) => props.onChange(e.target.value)}
//         disabled={props.disable}
//         labelname={props.labelname}
//       />
//     </>
//   );
// }

// export function CompetenciesDD(props) {
//   const [Options, SetOptions] = useState();
//   const GetCompetencies = async () => {
//     await axios
//       .get(
//         process.env.REACT_APP_API_BASE_URL +
//         `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=0&LovCategoryId=${props.LID}&ParentLovId=0`,
//         { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
//       )
//       .then((res) => {
//         const Options = res.data.map((item) => ({
//           display: item.lovDescription,
//           value: item.lovId,
//         }));
//         SetOptions(Options);
//         props.StoreMSource(props.SOption || "");
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   };

//   useEffect(() => {
//     GetCompetencies();
//   }, []);

//   return (
//     <>
//       <DropdownValues
//         Displayname={props.Displayname}
//         className={props.className}
//         options={Options}
//         selectoption={props.SOption}
//         onChange={(e) => props.onChange(e.target.value)}
//         disabled={props.disable}
//         labelname={props.labelname}
//       />
//     </>
//   );
// }
export function PLOneDD(props) {
  const [PLOneOptions, SetPLOneOptions] = useState();
  const GetPLOne = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/EnglishQuestionBank/GetProcessLevel1ById?SubjectId=${props.SID}&LovCategoryId=${props.LID}&ParentLovId=0&LanguageId=0`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetPLOneOptions(Options);
        props.StoreMSource(props.SOption || "");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    GetPLOne();
  }, []);

  return (
    <>
      <DropdownValues
        Displayname={props.Displayname}
        className={props.className}
        options={PLOneOptions}
        selectoption={props.SOption}
        onChange={(e) => props.onChange(e.target.value)}
        disabled={props.disable}
        labelname={props.labelname}
      />
    </>
  );
}

export function PLTwoDD(props) {
  const [PLTwoOptions, SetPLTwoOptions] = useState();
  const GetPLTwo = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/EnglishQuestionBank/GetProcessLevel2ById?SubjectId=${props.SID}&LovCategoryId=${props.LID}&ParentLovId=0&LanguageId=0`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )

      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetPLTwoOptions(Options);
        props.StoreMSource(props.SOption || "");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    GetPLTwo();
  }, []);

  return (
    <>
      <DropdownValues
        Displayname={props.Displayname}
        className={props.className}
        options={PLTwoOptions}
        selectoption={props.SOption}
        onChange={(e) => props.onChange(e.target.value)}
        disabled={props.disable}
        labelname={props.labelname}
      />
    </>
  );
}

export function PLThreeDD(props) {
  const [PLThreeOptions, SetPLThreeOptions] = useState();
  const GetPLThree = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SID}&LovCategoryId=${props.LID}&ParentLovId=0`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetPLThreeOptions(Options);
        props.StoreMSource(props.SOption || "");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    GetPLThree();
  }, []);

  return (
    <>
      <DropdownValues
        Displayname={props.Displayname}
        className={props.className}
        options={PLThreeOptions}
        selectoption={props.SOption}
        onChange={(e) => props.onChange(e.target.value)}
        disabled={props.disable}
        labelname={props.labelname}
      />
    </>
  );
}

export function GrammerDD(props) {
  const [GrammerOptions, SetGrammerOptions] = useState();
  const GetGrammer = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SID}&LovCategoryId=${props.LID}&ParentLovId=0`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetGrammerOptions(Options);
        props.StoreMSource(props.SOption || "");
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    GetGrammer();
  }, []);

  return (
    <>
      <DropdownValues
        Displayname={props.Displayname}
        className={props.className}
        options={GrammerOptions}
        selectoption={props.SOption}
        onChange={(e) => props.onChange(e.target.value)}
        disabled={props.disable}
        labelname={props.labelname}
      />
    </>
  );
}
// Below are the unit numbers and names 
export function UnitNumber(props) {
  const [UnitNumberOptions, SetUnitNumberOptions] = useState();
  const GetUnitNumber = async () => {
    try {
      const res = await axiosInstance.get(`/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SID}&LovCategoryId=${props.LoID}&ParentLovId=${props.PID}&LanguageId=${props.LID}`)
      const Options = res.data.map((item) => ({ display: item.lovDescription, value: item.lovId, }));
      SetUnitNumberOptions(Options);
      props.StoreMSource(props.SOption || "");
    }
    catch (err) { console.log(err) }
  };
  useEffect(() => { if (props.PID) { GetUnitNumber(); } }, [props.PID]);

  return (
    <DropdownValues Displayname={props.Displayname} className={props.className} options={UnitNumberOptions}
      selectoption={props.SOption} onChange={(e) => props.onChange(e.target.value)}
      disabled={props.disable} labelname={props.labelname} />
  );
}

export function UnitName(props) {
  const [UnitNameOptions, SetUnitNameOptions] = useState();
  const GetUnitName = async () => {
    try {
      const res = await axiosInstance.get(`/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SID}&LovCategoryId=${props.LoID}&ParentLovId=${props.PID}&LanguageId=${props.LID}`)
      const Options = res.data.map((item) => ({ display: item.lovDescription, value: item.lovId, }));
      SetUnitNameOptions(Options);
      props.StoreMSource(props.SOption || "");
    }
    catch (err) { console.log(err) }
  };
  useEffect(() => { if (props.PID) { GetUnitName(); } }, [props.PID]);

  return (
    <DropdownValues Displayname={props.Displayname} className={props.className} options={UnitNameOptions}
      selectoption={props.SOption} onChange={(e) => props.onChange(e.target.value)}
      disabled={props.disable} labelname={props.labelname} />
  );
}
// Above are the unit numbers and names 